import { P, Predicate } from "breadcommon";

export interface TransactionColumnFilterDisplayMerchantProps {
  predicate: Predicate;
}

export function TransactionColumnFilterDisplayMerchant({
  predicate,
}: TransactionColumnFilterDisplayMerchantProps): JSX.Element {
  const serializable = predicate.asSerializable();

  // Multi-select shape: P.Any(P.EqualsCI(...), ...)
  if (serializable.name === P.OpName.Any && serializable.args.length > 0) {
    const names: string[] = [];
    for (const arg of serializable.args) {
      if (
        (arg.name === P.OpName.EqualsCI ||
          arg.name === P.OpName.SubstringCI) &&
        arg.args.length === 2
      ) {
        const literalOp = arg.args[1];
        if (
          literalOp.name === P.OpName.Literal &&
          typeof literalOp.args[0] === "string"
        ) {
          names.push(literalOp.args[0]);
        }
      }
    }

    if (names.length === 0) {
      return <span>Merchant filter</span>;
    } else if (names.length === 1) {
      return <span>Merchant is {names[0]}</span>;
    } else if (names.length <= 3) {
      return <span>Merchant is {names.join(", ")}</span>;
    } else {
      return (
        <span>
          Merchant is {names.slice(0, 2).join(", ")}, +{names.length - 2} more
        </span>
      );
    }
  }

  // Legacy single-predicate shape: P.SubstringCI(...) or P.EqualsCI(...)
  if (
    (serializable.name === P.OpName.SubstringCI ||
      serializable.name === P.OpName.EqualsCI) &&
    serializable.args.length === 2
  ) {
    const literalOp = serializable.args[1];
    if (
      literalOp.name === P.OpName.Literal &&
      typeof literalOp.args[0] === "string"
    ) {
      const isExact = serializable.name === P.OpName.EqualsCI;
      return (
        <span>
          Merchant {isExact ? "is" : "contains"} "{literalOp.args[0]}"
        </span>
      );
    }
  }

  return <span>Merchant filter</span>;
}
